export const LANGUAGE_SPEECH_CONFIG = {
  English: { code: 'en-US', rate: 0.9 },
  Spanish: { code: 'es-ES', rate: 0.9 },
  Mandarin: { code: 'zh-CN', rate: 0.85 },
  Japanese: { code: 'ja-JP', rate: 0.85 },
  French: { code: 'fr-FR', rate: 0.9 },
  German: { code: 'de-DE', rate: 0.9 },
  Italian: { code: 'it-IT', rate: 0.9 },
  Korean: { code: 'ko-KR', rate: 0.85 },
  Portuguese: { code: 'pt-PT', rate: 0.9 },
  Arabic: { code: 'ar-SA', rate: 0.9 },
};

export const getLanguageSpeechConfig = (language) => LANGUAGE_SPEECH_CONFIG[language] || LANGUAGE_SPEECH_CONFIG.English;
